import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardVenuesDataApi } from '../../../api/dashboard/adminGetDashboardVenuesDataApi';
import { AdminDashboardDataFilter, AdminDashboardVenuesStaticsResponse } from '../../../graphql/API';

export const useAdminGetDashboardVenuesDataQuery = (
  filter: AdminDashboardDataFilter,
): UseQueryResult<AdminDashboardVenuesStaticsResponse, Error> => {
  const adminGetDashboardQuery = useQuery({
    queryKey: ['admin-get-dashboard-venues-data', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardDataFilter];
      const response = await adminGetDashboardVenuesDataApi(filter);
      return response;
    },
    enabled: !!filter.fromDate || !!filter.toDate || !!filter.priorFromDate || !!filter.priorToDate,
  });
  return { ...adminGetDashboardQuery };
};
